import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import router from '@/router';
import queryString from 'query-string';

import request from './request';

Vue.use(Vuex);

const test = new Vuex.Store({
    state: {
        transactions: {
            current_page: 1,
            page_number: 1,
            data: [],
            total: 0
        },
        messages: [],
        notifications: [],
        leads: {
            current_page: 1,
            page_number: 1,
            data: [],
            total: 0
        },
        stores: [],
        attending_stores: [],
        user_store_report: null,
        current_attending: null,
        sale_platforms: [],
        contact_statuses: [],
        drop_checkout_delays: [],
        selectedTransaction: null,
        transactionStatus: [],
        leadSegmentations: [],
        leadSegmentationLeads: [],
        sales_report: {},
        product_sales_report: {},
        geo_sales_report: {},
        leadsFilters: {
            page: 1
        },
        transactionFilters: {
            cpfcnpj: '',
            pay_type: [],
            status: ['Finalizada'],
            search: '',
            page: 1,
            start_date: moment().startOf('month').format('YYYY-MM-DD'),
            end_date: moment().endOf('month').format('YYYY-MM-DD'),
        },
        emails: [],
        user: null,
        detailsDialog: false,
        trackCodeDialog: false,
        ticketsDialog: false,
        contentDeclarationDialog: false,
        snackbar: {
            open: false,
            text: '',
            timeout: 3000,
            color: 'default'
        },
        products: [],
        loading: false,
        attending_transaction: null,
        google_oauth2: [],
        user_roles: [],
        user_plan: null,
        google_unused_oauth2: [],
        tags: [],
        invites: [],
        attending_history: {
            current_page: 1,
            page_number: 1,
            data: [],
            total: 0,
        },
        attending_history_filters: {
            search: '',
            page: 1,
            prevRequest: null
        },
        attending_schedules: [

        ]
    },
    mutations: {
        setUserRoles: (state, payload) => state.user_roles = payload.data,
        setUserPlan: (state, payload) => state.user_plan = payload.data,
        setSubAttendingSchedules: (state, payload) => state.attending_schedules = payload.data,
        setAttendingHistoryRequest: (state, payload) => state.attending_history_filters.prevRequest = payload,
        setAttendingHistorySearch: (state, payload) => state.attending_history_filters.search = payload,
        setCurrentAttending: (state, payload) => state.current_attending = payload.data,
        setMessages: (state, payload) => state.messages = payload.data,
        setNotifications: (state, payload) => state.notifications = payload.data,
        setSegmentationLeads: (state, payload) => state.leadSegmentationLeads = payload.data,
        setInvites: (state, payload) => state.invites = payload.data,
        setUserOauth2AccessToken: (state, payload) => state.user.g_access_token = payload.data,
        setUnusedGoogleOauth2: (state, payload) => state.google_unused_oauth2 = payload.data,
        setGoogleOauth2: (state, payload) => state.google_oauth2 = payload.data,
        setTransactions: (state, payload) => state.transactions = payload.data,
        setAttendingHistory: (state, payload) => state.attending_history = payload.data,
        setAttendingTransactions: (state, payload) => state.attending_transaction = payload.data,
        setLeads: (state, payload) => state.leads = payload.data,
        setTags: (state, payload) => state.tags = payload.data,
        setContactStatuses: (state, payload) => state.contact_statuses = payload.data,
        setSalePlatforms: (state, payload) => state.sale_platforms = payload.data,
        setDropCheckoutDelays: (state, payload) => state.drop_checkout_delays = payload.data,
        setSalesReport: (state, payload) => state.sales_report = payload.data,
        setProductSalesReport: (state, payload) => state.product_sales_report = payload.data,
        setGeoSalesReport: (state, payload) => state.geo_sales_report = payload.data,
        setProducts: (state, payload) => state.products = payload.data,
        setEmails: (state, payload) => state.emails = payload.data,
        setStores: (state, payload) => state.stores = payload.data,
        setPaymentsMethods: (state, payload) => state.payments_methods = payload.data,
        setAttendingStores: (state, payload) => state.attending_stores = payload.data,
        setUserStoreReport: (state, payload) => state.user_store_report = payload.data,
        setConfirmedPayments: (state, payload) => state.confirmed_payments = payload.data,
        setBilletsExpired: (state, payload) => state.billets_expired = payload.data,
        setTransactionStatus: (state, payload) => state.transactionStatus = payload.data,
        setTransactionsPage: (state, payload) => state.transactionFilters.page = payload,
        setAttendingHistoryPage: (state, payload) => state.attending_history_filters.page = payload,
        setLeadsPage: (state, payload) => state.leadsFilters.page = payload,
        setSegmentations: (state, payload) => state.leadSegmentations = payload.data,
        deleteLeadSegmentation: (state, payload) => {
            const index = state.leadSegmentations.map(ls => ls.id).indexOf(payload.data.id);
            state.leadSegmentations.splice(index, 1);
        },
        deleteGOauth2: (state, payload) => {
            const index = state.google_oauth2.map(e => e.id).indexOf(payload.data.id);
            state.google_oauth2.splice(index, 1);
        },
        deleteEmail: (state, payload) => {
            const index = state.emails.map(e => e.id).indexOf(payload.data.id);
            state.emails.splice(index, 1);
        },
        deleteStore: (state, payload) => {
            const index = state.stores.map(e => e.id).indexOf(payload.data.id);
            state.stores.splice(index, 1);
        },
        deleteMessage: (state, payload) => {
            const index = state.messages.map(e => e.id).indexOf(payload.data.id);
            state.messages.splice(index, 1);
        },
        createLeadSegmentation: (state, payload) => {
            state.leadSegmentations = [
                ...state.leadSegmentations.filter(ls => ls.id != payload.id), payload
            ]
        },
        createSubAttendingSchedule: (state, payload) => {
            state.attending_schedules =
                state.attending_schedules.map(schedule => {
                    if (schedule.id === payload.id) {
                        return Object.assign({}, {...schedule }, {...payload }, {
                            transaction: {...payload.transaction }
                        });
                    } else {
                        return schedule;
                    }
                });
        },
        createGoogleOauth2: (state, payload) => {
            state.google_oauth2 = [
                ...state.google_oauth2.filter(g => g.id != payload.data.id), payload.data
            ]
        },
        createEmail: (state, payload) => {
            state.emails = [
                ...state.emails.filter(e => e.id != payload.id), payload
            ]
        },
        updateUserStore: (state, payload) => {
            state.attending_stores = [
                ...state.attending_stores.filter(e => e.id != payload.id), payload
            ]
        },
        createStore: (state, payload) => {
            state.stores = [
                ...state.stores.filter(e => e.id != payload.id), payload
            ]
        },
        createMessage: (state, payload) => {
            state.messages = [
                ...state.messages.filter(e => e.id != payload.id), payload
            ]
        },
        createNotification: (state, payload) => {
            state.notifications = [
                ...state.notifications.filter(e => e.id != payload.id), payload
            ]
        },
        setUser: (state, payload) => state.user = payload.data,
        setTransactionFilters: (state, payload) => state.transactionFilters = payload.data,
        setTransactionsQuery: (state, payload) => state.transactionFilters.search = payload,
        setTrackCodeDialog: (state, payload) => {
            if (!payload) {
                state.trackCodeDialog = false;
            } else {
                state.trackCodeDialog = true;
                state.selectedTransaction = payload.data
            }
        },
        setDetailsDialog: (state, payload) => {
            if (!payload) {
                state.detailsDialog = false;
            } else {
                state.detailsDialog = true;
                state.selectedTransaction = payload.data
            }
        },
        setTicketsDialog: (state, payload) => {
            if (!payload) {
                state.ticketsDialog = false;
            } else {
                state.ticketsDialog = true;
            }
        },
        setContentDeclarationDialog: (state, payload) => {
            if (!payload) {
                state.contentDeclarationDialog = false;
            } else {
                state.contentDeclarationDialog = true;
            }
        },
        setLoading: (state, payload) => state.loading = payload.data,
        alertError: (state, payload) => state.snackbar = {
            open: true,
            color: 'error',
            text: payload
        },
        alertSuccess: (state, payload) => state.snackbar = {
            open: true,
            color: 'success',
            text: payload
        },
    },
    actions: {
        setTransactionsPage({ commit }, payload) {
            commit('setTransactionsPage', payload);
        },
        setAttendingHistorySearch({ commit, dispatch }, payload) {
            commit('setAttendingHistorySearch', payload)
            dispatch('fetchAttendingHistory', router.currentRoute.params.uuid);
        },
        setLeadsPage({ commit }, payload) {
            commit('setLeadsPage', payload);
        },
        fetchTransactions({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: `/api/transactions?${queryString.stringify(state.transactionFilters, {arrayFormat: 'bracket'})}`,
                    auth: true,
                })
                .then(response => {
                    commit('setTransactions', response);
                    commit('alertSuccess', 'Transações carregadas com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar transações');
                    dispatch('hideLoading');
                });
        },
        fetchAttendingHistory({ dispatch, commit, state }, store_uuid) {
            const url = `/api/attendings/subattendings/history/${store_uuid}`;

            request({
                    method: 'get',
                    url: url + `?${queryString.stringify(state.attending_history_filters, {arrayFormat: 'bracket'})}`,
                    auth: true,
                })
                .then(response => {
                    commit('setAttendingHistory', response);
                    commit('alertSuccess', 'Histórico de atendimento carregado com sucesso');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar transações');
                })

        },
        fetchAttendStoreByUuid({ dispatch, commit, state }, store_uuid) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: `/api/userstore/store-uuid/${store_uuid}`,
                    auth: true,
                })
                .then(response => {
                    commit('setCurrentAttending', response);
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar transações');
                    dispatch('hideLoading');
                });
        },
        fetchAttendingStoreTransactions({ dispatch, commit, state }, store_uuid) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: `/api/stores/${store_uuid}/transaction`,
                    auth: true,
                })
                .then(response => {
                    commit('setAttendingTransactions', response);
                    commit('alertSuccess', 'Transações carregadas com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar transações');
                    dispatch('hideLoading');
                });
        },
        fetchMessages({ dispatch, commit, state }, store_uuid) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/messages',
                    auth: true,
                })
                .then(response => {
                    commit('setMessages', response);
                    commit('alertSuccess', 'Mensagens carregadas com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar as mensagens');
                    dispatch('hideLoading');
                });
        },
        fetchNotifications({ dispatch, commit, state }, store_uuid) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/notification',
                    auth: true,
                })
                .then(response => {
                    commit('setNotifications', response);
                    commit('alertSuccess', 'Notificações carregadas com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar as notificações');
                    dispatch('hideLoading');
                });
        },
        fetchSegmentationLeads({ dispatch, commit }, segment) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: `/api/customers/segmentations/${segment.id}/leads`,
                    auth: true,
                })
                .then(response => {
                    commit('setSegmentationLeads', response);
                    dispatch('hideLoading');
                })
                .catch(err => {
                    dispatch('hideLoading');
                });
        },

        fetchTags({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/tags',
                    auth: true,
                })
                .then(response => {
                    commit('setTags', response);
                    dispatch('hideLoading');
                })
                .catch(err => {
                    dispatch('hideLoading');
                });
        },
        fetchSubAttendingSchedules({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/attendings/subattendings/schedules',
                    auth: true,
                })
                .then(response => {
                    commit('setSubAttendingSchedules', response);
                    dispatch('hideLoading');
                })
                .catch(err => {
                    dispatch('hideLoading');
                });
        },
        acceptInvite({ dispatch, commit }, invite) {
            return request({
                    method: 'get',
                    url: `/api/invites/${invite.token}/${invite.answer}`,
                    auth: true,
                })
                .then(response => {
                    dispatch('fetchInvites');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    dispatch('hideLoading');
                });
        },
        fetchLeads({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: `/api/leads?${queryString.stringify(state.leadsFilters, {arrayFormat: 'comma'})}`,
                    auth: true,
                })
                .then(response => {
                    commit('setLeads', response);
                    commit('alertSuccess', 'Leads carregadas com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar leads');
                    dispatch('hideLoading');
                });
        },
        checkInvite({ dispatch, commit, state }, payload) {
            dispatch('showLoading');
            const { data } = payload;
            request({
                    method: 'get',
                    url: `/api/invite/check/${data.token}`,
                })
                .then(response => {
                    router.push(response.data);
                    /*commit('alertSuccess', 'Leads carregadas com sucesso');*/
                    dispatch('hideLoading');
                })
                .catch(err => {
                    /*commit('alertError', 'Falha ao carregar leads');*/
                    dispatch('hideLoading');
                });
        },
        fetchAttendantStores({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/attendants',
                    auth: true,
                })
                .then(response => {
                    commit('setAttendingStores', response);
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar seus atendentes');
                    dispatch('hideLoading');
                });
        },
        fetchUserStoreReport({ dispatch, commit, state }, {filters, callback}) {
            const params = Object.keys(filters)
                .map(key => key + '=' + filters[key])
                .join('&');
            
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/reports/userstore?' + params,
                    auth: true,
                })
                .then(response => {
                    if(callback) callback();

                    commit('setUserStoreReport', response);
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao gerar o relatório');
                    dispatch('hideLoading');
                });
        },
        fetchConfirmedPayments({ dispatch, commit, state }, {filters, callback}) {
            const params = Object.keys(filters)
                .map(key => key + '=' + filters[key])
                .join('&');
            
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/attendings/subattending/paid?' + params,
                    auth: true,
                })
                .then(response => {
                    if(callback) callback();

                    commit('setConfirmedPayments', response);
                    commit('alertSuccess', 'Transações carregadas com sucesso!');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao gerar o relatório');
                    dispatch('hideLoading');
                });
        },
        fetchBilletsExpired({ dispatch, commit, state }, {filters, callback}) {
            const params = Object.keys(filters)
                .map(key => key + '=' + filters[key])
                .join('&');
            
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/attendings/subattending/expired?' + params,
                    auth: true,
                })
                .then(response => {
                    if(callback) callback();

                    commit('setBilletsExpired', response);
                    commit('alertSuccess', 'Transações carregadas com sucesso!');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao gerar o relatório');
                    dispatch('hideLoading');
                });
        },
        fetchUserRoles({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/user_roles',
                    auth: true,
                })
                .then(response => {
                    commit('setUserRoles', response);
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar níveis de usuário');
                    dispatch('hideLoading');
                });
        },
        fetchUserPlan({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/user_plan',
                    auth: true,
                })
                .then(response => {
                    commit('setUserPlan', response);
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar níveis de usuário');
                    dispatch('hideLoading');
                });
        },
        fetchLeadSegmentations({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/customers/segmentations',
                    auth: true,
                })
                .then(response => {
                    commit('setSegmentations', response);
                    commit('alertSuccess', 'Segmentos carregados com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar segmentos');
                    dispatch('hideLoading');
                });
        },
        fetchProducts({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/products',
                    auth: true,
                })
                .then(response => {
                    commit('setProducts', response);
                    commit('alertSuccess', 'Produtos carregadas com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar produtos');
                    dispatch('hideLoading');
                });
        },
        fetchUnusedGOauth2({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/oauth2/google-unused',
                    auth: true,
                })
                .then(response => {
                    commit('setUnusedGoogleOauth2', response);
                    commit('alertSuccess', 'Contas do Google carregadas com sucesso!');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar contas do Google');
                    dispatch('hideLoading');
                });
        },
        fetchGOauth2({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/oauth2/google',
                    auth: true,
                })
                .then(response => {
                    commit('setGoogleOauth2', response);
                    commit('alertSuccess', 'Contas do Google carregadas com sucesso!');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar contas do Google');
                    dispatch('hideLoading');
                });
        },

        fetchSalePlatforms({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/integrations/sale-platforms',
                    auth: true,
                })
                .then(response => {
                    commit('setSalePlatforms', response);
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar plataformas de pedido');
                    dispatch('hideLoading');
                });
        },
        fetchContactStatuses({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/stores/contact-statuses',
                    auth: true,
                })
                .then(response => {
                    commit('setContactStatuses', response);
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar tempos para abandono de carrinho');
                    dispatch('hideLoading');
                });
        },
        fetchDropCheckoutDelays({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/stores/drop-checkout-delays',
                    auth: true,
                })
                .then(response => {
                    commit('setDropCheckoutDelays', response);
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar tempos para abandono de carrinho');
                    dispatch('hideLoading');
                });
        },
        fetchTransactionStatus({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/transactions/status',
                    auth: true,
                })
                .then(response => {
                    commit('setTransactionStatus', response);
                    commit('alertSuccess', 'Status de transações carregados com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar status de transações');
                    dispatch('hideLoading');
                });
        },
        async attendStoreTransaction({ dispatch, commit, state }, { store, attending }) {
            dispatch('showLoading');
            const a = request({
                method: 'post',
                url: '/api/attendings',
                auth: true,
                data: {
                    attending
                }
            });
        },
        fetchEmails({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/emails',
                    auth: true,
                })
                .then(response => {
                    commit('setEmails', response);
                    commit('alertSuccess', 'Emails carregados com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar emails');
                    dispatch('hideLoading');
                });
        },
        fetchStores({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/stores',
                    auth: true,
                })
                .then(response => {
                    commit('setStores', response);
                    commit('alertSuccess', 'Lojas carregadas com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar lojas');
                    dispatch('hideLoading');
                });
        },
        fetchPaymentsMethods({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/paymentsmethods',
                    auth: true,
                })
                .then(response => {
                    commit('setPaymentsMethods', response);
                    commit('alertSuccess', 'Métodos de pagamento carregados com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar métodos de pagamento');
                    dispatch('hideLoading');
                });
        },
        fetchAttendingStores({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/stores/attending',
                    auth: true,
                })
                .then(response => {
                    commit('setAttendingStores', response);
                    commit('alertSuccess', 'Lojas carregadas com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar lojas');
                    dispatch('hideLoading');
                });
        },
        fetchInvites({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/invites',
                    auth: true,
                })
                .then(response => {
                    commit('setInvites', response);
                    commit('alertSuccess', 'Convites carregadas com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar lojas');
                    dispatch('hideLoading');
                });
        },
        fetchSalesReport({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/transactions/reports/weekly_sales',
                    auth: true,
                })
                .then(response => {
                    commit('setSalesReport', response);
                    commit('alertSuccess', 'Relatório carregado com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar relatório');
                    dispatch('hideLoading');
                });
        },
        fetchProductSalesReport({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/transactions/reports/products_sales',
                    auth: true,
                })
                .then(response => {
                    commit('setProductSalesReport', response);
                    commit('alertSuccess', 'Relatório carregado com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar relatório');
                    dispatch('hideLoading');
                });
        },
        fetchGeoSalesReport({ dispatch, commit, state }) {
            dispatch('showLoading');
            request({
                    method: 'get',
                    url: '/api/transactions/reports/geo_sales',
                    auth: true,
                })
                .then(response => {
                    commit('setGeoSalesReport', response);
                    commit('alertSuccess', 'Relatório carregado com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao carregar relatório');
                    dispatch('hideLoading');
                });
        },
        setTransactionFilters({ dispatch, commit }, payload) {
            commit('setTransactionFilters', payload);
        },
        setTransactionsQuery({ dispatch, commit }, payload) {
            commit('setTransactionsQuery', payload);
        },
        setTrackCodeDialog({ commit }, payload) {
            commit('setTrackCodeDialog', payload);
        },
        setTicketsDialog({ commit }, payload) {
            commit('setTicketsDialog', payload);
        },
        setContentDeclarationDialog({ commit }, payload) {
            commit('setContentDeclarationDialog', payload);
        },
        setDetailsDialog({ commit }, payload) {
            commit('setDetailsDialog', payload);
        },
        async fetchUser({ commit }) {
            return request({
                auth: true,
                method: 'get',
                url: '/api/auth/user'
            });
        },
        showLoading({ commit }) {
            commit('setLoading', { data: true });
        },
        logout({ commit }) {
            request({
                    method: 'get',
                    url: '/api/auth/logout',
                    auth: true
                })
                .then(response => {
                    commit('setUser', { data: null });
                    commit('alertSuccess', 'Usuário deslogado com sucesso');
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('user');
                    router.push('/login');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao deslogar o usuário');
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('user');
                    router.push('/login');
                })
        },
        async login({ dispatch, commit, state }, payload) {
            dispatch('showLoading');
            /*Get the access_token from the easytools api*/
            request({
                    url: '/api/auth/login',
                    data: payload.data,
                    method: 'post'
                })
                .then(response => {
                    /*Keep the access_token in the localStorage for future requests*/
                    localStorage.setItem('access_token', response.data.access_token);
                    /*Get the authenticated user data based with the access_token*/
                    return dispatch('fetchUser');
                })
                .then(response => {
                    const { data } = response;
                    /*Store the user information in localStorage*/
                    localStorage.setItem('user', JSON.stringify(data));
                    /*Store the user information in the vuex Store*/
                    dispatch('setUser', { data });
                    /*After the user is authenticated, redirect him to the transactions view*/
                    router.push('/dashboard');
                    /*Remove the loading screen*/
                    dispatch('hideLoading');
                })
                .catch(error => {
                    commit('alertError', 'Falha ao autenticar, verifique os dados!');
                    /*Remove the loading screen*/
                    dispatch('hideLoading');
                });
        },
        async register({ dispatch, commit, state }, payload) {
            dispatch('showLoading');
            /*Register the user and retrieve the access_token from the easytools api*/
            request({
                    url: '/api/auth/register',
                    data: payload.data,
                    method: 'post'
                })
                .then(response => {
                    commit('alertSuccess', 'Cadastro realizado com sucesso com sucesso');
                    /*Keep the access_token in the localStorage for future requests*/
                    localStorage.setItem('access_token', response.data.access_token);
                    /*Get the authenticated user data based with the access_token*/
                    return dispatch('fetchUser');
                })
                .then(response => {
                    const { data } = response;
                    /*Store the user information in localStorage*/
                    localStorage.setItem('user', JSON.stringify(data));
                    /*Store the user information in the vuex Store*/
                    dispatch('setUser', { data });
                    /*After the user is authenticated, redirect him to the transactions view*/
                    router.push('/profile');
                    /*Remove the loading screen*/
                    dispatch('hideLoading');
                })
                .catch(error => {
                    if (error.response && error.response.data && error.response.data.errors) {
                        if (error.response.data.errors.email.length > 0) {
                            switch (error.response.data.errors.email[0]) {
                                case 'The email has already been taken.':
                                    commit('alertError', 'Este email já está sendo utilizado');
                                    break;
                                case 'The email must be a valid email address.':
                                    commit('alertError', 'O endereço de email inserido é inválido');
                                    break;
                            }
                        }
                    } else {
                        commit('alertError', 'Falha ao cadastrar usuário, verifique os dados!');
                    }
                    /*Remove the loading screen*/
                    dispatch('hideLoading');
                });
        },
        hideLoading({ commit }) {
            commit('setLoading', { data: false });
        },
        setUser({ commit }, payload) {
            commit('setUser', payload);
        },
        sendTrackCode({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { data } = payload;
            request({
                    method: 'post',
                    url: '/api/customers/send-track-code',
                    auth: true,
                    data
                })
                .then(response => {
                    commit('alertSuccess', 'Código enviado com sucesso!');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao enviar código de rastramento!');
                    dispatch('hideLoading');
                });
        },
        forgotPassword({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const data = payload;
            request({
                    method: 'post',
                    url: '/api/auth/password/email',
                    auth: true,
                    data
                })
                .then(response => {
                    commit('alertSuccess', 'Verifique seu email para redefinir a senha!');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao enviar código de rastramento!');
                    dispatch('hideLoading');
                });
        },
        resetPassword({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const data = payload;
            request({
                    method: 'post',
                    url: '/api/auth/reset',
                    auth: true,
                    data
                })
                .then(response => {
                    commit('alertSuccess', 'Senha redefinida com sucesso!');
                    router.push('/login');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao enviar código de rastramento!');
                    dispatch('hideLoading');
                });
        },
        createLeadSegmentation({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { data } = payload;
            request({
                    method: 'post',
                    url: '/api/customers/segmentations',
                    auth: true,
                    data
                })
                .then(response => {
                    commit('createLeadSegmentation', response.data);
                    commit('alertSuccess', 'Segmento de leads cadastrado/atualizado com sucesso!');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    /*commit('alertError', 'Falha ao cadastrar segmento de leads!');*/
                    dispatch('hideLoading');
                });
        },
        createMessage({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { data } = payload;
            request({
                    method: 'post',
                    url: '/api/messages',
                    auth: true,
                    data
                })
                .then(response => {
                    commit('createMessage', response.data);
                    commit('alertSuccess', 'Mensagem cadastrada com sucesso!');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    dispatch('hideLoading');
                });

        },
        createNotification({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { data } = payload;
            request({
                    method: 'post',
                    url: '/api/notification',
                    auth: true,
                    data
                })
                .then(response => {
                    commit('createNotification', response.data);
                    commit('alertSuccess', 'Notificação cadastrada com sucesso!');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    dispatch('hideLoading');
                });

        },
        createSubAttendingSchedule({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { data } = payload;
            const url = `/api/attendings/subattending/${data.subattending}/schedule`;

            return request({
                    method: 'post',
                    url: url,
                    auth: true,
                    data
                })
                .then(response => {
                    commit('createSubAttendingSchedule', response.data);
                    commit('alertSuccess', 'Atendimento agendado com sucesso');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    dispatch('hideLoading');
                    commit('alertError', 'Erro ao agendar o atendimento. Tente Novamente!');
                });

        },
        updateUserStore({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const data = payload;
            request({
                    method: 'put',
                    url: '/api/stores/attending',
                    auth: true,
                    data
                })
                .then(response => {
                    commit('updateUserStore', response.data);
                    commit('alertSuccess', 'Atendimento atualizado com sucesso!');
                    dispatch('hideLoading');
                    return true;
                })
                .catch(err => {
                    commit('alertError', 'Falha ao cadastrar Email!');
                    dispatch('hideLoading');
                    return false;
                });
        },
        setUserStoreActive({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const data = payload;
            request({
                    method: 'post',
                    url: '/api/stores/attending/set-active',
                    auth: true,
                    data
                })
                .then(response => {
                    commit('updateUserStore', response.data);
                    commit('alertSuccess', 'Atendimento atualizado com sucesso!');
                    dispatch('hideLoading');
                    return true;
                })
                .catch(err => {
                    commit('alertError', 'Falha ao cadastrar Email!');
                    dispatch('hideLoading');
                    return false;
                });
        },
        createEmail({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { data } = payload;
            request({
                    method: 'post',
                    url: '/api/emails',
                    auth: true,
                    data
                })
                .then(response => {
                    commit('createEmail', response.data);
                    commit('alertSuccess', 'Email cadastrado/atualizado com sucesso!');
                    dispatch('hideLoading');
                    return true;
                })
                .catch(err => {
                    commit('alertError', 'Falha ao cadastrar Email!');
                    dispatch('hideLoading');
                    return false;
                });
        },
        createAttendant({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { data } = payload;
            request({
                    method: 'post',
                    url: '/api/attendants',
                    auth: true,
                    data
                })
                .then(response => {
                    if(response.data.id) {
                        commit('createAttendant', response.data);
                        commit('alertSuccess', 
                            'Sucesso! O atendente começará a atender assim que aceitar o convite!'
                        );
                    }
                    else if(response.data == "limite de atendentes"){
                        commit('alertError', 'Você atingiu o máximo de atendentes ativos que seu plano permite!');
                    }

                    else  {
                        commit('alertSuccess', 'Atendente atualizado com sucesso!');
                    }
                    
                    dispatch('hideLoading');
                    return true;
                })
                .catch(err => {
                    commit('alertError', 'Falha ao cadastrar Atendente! Verifique os dados informados.');
                    dispatch('hideLoading');
                    return false;
                });
        },
        createStore({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { data } = payload;
            request({
                    method: 'post',
                    url: '/api/stores',
                    auth: true,
                    data
                })
                .then(response => {
                    commit('createStore', response.data);
                    commit('alertSuccess', 'Loja cadastrada/atualizada com sucesso!');
                    dispatch('hideLoading');
                    return true;
                })
                .catch(err => {
                    commit('alertError', 'Falha ao cadastrar Loja! Por favor revise as informações');
                    dispatch('hideLoading');
                    return false;
                });
        },
        createGoogleOauth2({ dispatch, commit, state }, payload) {
            dispatch('showLoading');
            const { data } = payload;
            request({
                    method: 'post',
                    url: '/api/oauth2/google',
                    auth: true,
                    data
                })
                .then(response => {
                    commit('createGoogleOauth2', { data: response.data });
                    localStorage.setItem('user', JSON.stringify(state.user));
                    commit('alertSuccess', 'Autenticação Google Autorizada!');
                    dispatch('hideLoading');
                    return true;
                })
                .catch(err => {
                    commit('alertError', 'Falha ao autorizar a autenticação com o Google');
                    dispatch('hideLoading');
                    return false;
                });
        },
        deleteLeadSegmentation({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { params } = payload;
            request({
                    method: 'delete',
                    url: '/api/customers/segmentations',
                    auth: true,
                    params
                })
                .then(response => {
                    commit('deleteLeadSegmentation', { data: params });
                    commit('alertSuccess', 'Segmento de leads removido com sucesso!');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao remover segmento de leads!');
                    dispatch('hideLoading');
                });
        },
        deleteEmail({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { params } = payload;
            request({
                    method: 'delete',
                    url: '/api/emails',
                    auth: true,
                    params
                })
                .then(response => {
                    commit('deleteEmail', { data: params });
                    commit('alertSuccess', 'Email removido com sucesso!');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao remover Email!');
                    dispatch('hideLoading');
                });
        },
        deleteGOauth2({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { params } = payload;
            request({
                    method: 'delete',
                    url: '/api/oauth2/google',
                    auth: true,
                    params
                })
                .then(response => {
                    commit('deleteGOauth2', { data: params });
                    commit('alertSuccess', 'Conta do Google removida com sucesso!');
                    dispatch('hideLoading');
                })
                .catch(err => {
                    commit('alertError', 'Falha ao remover Conta do Google!');
                    dispatch('hideLoading');
                });
        },
        deleteStore({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { params } = payload;
            request({
                    method: 'delete',
                    url: '/api/stores',
                    auth: true,
                    params
                })
                .then(response => {
                    if (response) {
                        commit('deleteStore', { data: params });
                    }
                    dispatch('hideLoading');
                })
                .catch(err => {
                    dispatch('hideLoading');
                });
        },
        deleteMessage({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { params } = payload;
            request({
                    method: 'delete',
                    url: '/api/messages',
                    auth: true,
                    params
                })
                .then(response => {
                    if (response) {
                        commit('deleteMessage', { data: params });
                    }

                    dispatch('hideLoading');
                })
                .catch(err => {
                    dispatch('hideLoading');
                });
        },
        deleteAttendant({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { params } = payload;
            request({
                    method: 'delete',
                    url: '/api/attendants',
                    auth: true,
                    params
                })
                .then(response => {
                    if (response) {
                        commit('deleteAttendant', { data: params });
                        commit('alertSuccess', 'Atendente removido com sucesso!');
                    }
                    dispatch('hideLoading');
                })
                .catch(err => {
                    dispatch('hideLoading');
                });
        },
        deleteNotification({ dispatch, commit }, payload) {
            dispatch('showLoading');
            const { params } = payload;
            request({
                    method: 'delete',
                    url: '/api/notification',
                    auth: true,
                    params
                })
                .then(response => {
                    if (response) {
                        commit('deleteNotification', { data: params });
                        commit('alertSuccess', 'Notificação removida com sucesso!');
                    }
                    dispatch('hideLoading');
                })
                .catch(err => {
                    dispatch('hideLoading');
                });
        }
    },
})

export default test;